module.exports = __webpack_public_path__ + "static/accordiondefault-977266c352dcb444507d996d8692dcde.png";